module.exports = __webpack_public_path__ + "/static/sito/landing/agenti-zero-emissioni/media/energiaDue.9e43a569.pdf";